const INVALID_QUERY_VALUES = new Set(["null", "undefined"]);
const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function isUsableQueryValue(value: string | null): value is string {
  if (value == null) {
    return false;
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return false;
  }

  return !INVALID_QUERY_VALUES.has(trimmed.toLowerCase());
}

/**
 * PawaPay may keep merchant params, replace the query with depositId, or
 * concatenate a second `?` instead of `&`. Normalize extra `?` so both keys parse.
 */
export function parseReturnSearchParams(search: string): URLSearchParams {
  const raw = search.startsWith("?") ? search.slice(1) : search;
  return new URLSearchParams(raw.replace(/\?/g, "&"));
}

export function resolvePaymentStatusReference(search: string): string | null {
  const params = parseReturnSearchParams(search);

  const reference = params.get("reference");
  if (isUsableQueryValue(reference)) {
    return reference.trim();
  }

  const txRef = params.get("tx_ref");
  if (isUsableQueryValue(txRef)) {
    return txRef.trim();
  }

  const depositId = params.get("depositId");
  if (isUsableQueryValue(depositId)) {
    const id = depositId.trim();
    if (UUID_PATTERN.test(id)) {
      return id;
    }
  }

  return null;
}
